import styled from "@emotion/styled";
import theme from "../../theme";
import { CustomTooltip } from "../common/CustomTooltip";
import {
  formatDate,
  handleKeyDown,
  textSubstring,
} from "../../utils/util";
import { deviceImageArray } from "../../utils/deviceImageArray";
import {
  DetectTodayResult,
  GetMobilityLive,
  MobileInfo,
  Mobility,
} from "../../types/types";
import Spinner from "../spinner";
import { Pagination } from "@mui/material";
import { useWindowSize } from "@reactuses/core";
import { useEffect, useState } from "react";
import { useI18n } from "../../locales";
// import { DotLoader } from "../dotLoader";

const { sm, md, lg } = theme.screen;

type Prop = {
  data?: GetMobilityLive | DetectTodayResult;
  mobilityData: Mobility | undefined;
  mobilityDataIsLoading: boolean;
  selectedMobility: MobileInfo | null;
  handleClickMobilityList: (el: MobileInfo) => void;
  listRef?: React.RefObject<HTMLDivElement>;
  mobilityPage: number;
  setMobilityPage: React.Dispatch<React.SetStateAction<number>>;
};
// 보유 기기 목록
export const MobilityList = ({
  data,
  mobilityData,
  mobilityDataIsLoading,
  selectedMobility,
  handleClickMobilityList,
  listRef,
  mobilityPage,
  setMobilityPage,
}: Prop) => {
  const { width } = useWindowSize();
  const { t } = useI18n();
  const [mobSubstringLength, setMobSubstringLength] = useState(19);

  const isLeased = data && !!data.lease_name; // 임차인 존재하는지 여부

  useEffect(() => {
    if (width > lg) {
      setMobSubstringLength(31);
      return;
    }
    if (width > md && width <= lg) {
      setMobSubstringLength(27);
      return;
    }
    if (width <= md) {
      setMobSubstringLength(17);
      return;
    }
  }, [width]);

  const handlePageChange = (
    // 페이지네이션
    _: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setMobilityPage(value - 1);
  };

  return (
    <MobilityWrapperStyledDiv>
      <ListTitleStyledH2>{t.control.ownedDeviceList}</ListTitleStyledH2>
      {/* 현재 선택된 보유 기기 */}
      <SelectedMobWrapper>
        {/* 로딩중  */}
        {/* {!selectedMobility && mobilityDataIsLoading && (
          <LoaderWrapper>
            <DotLoader width="60px" height="12px" />
          </LoaderWrapper>
        )} */}

        {/* 선택된 데이터 있음 - 임차인 없음 */}
        {selectedMobility && !mobilityDataIsLoading && !isLeased && (
          <ListItemStyledDiv
            hoverColor={theme.color.neutral_100}
            key={selectedMobility.device_pid}
            active={true}
          >
            <ImageWrapperStyledDiv
              bgColor={
                selectedMobility?.status === "운행중"
                  ? theme.color.green_100
                  : theme.color.neutral_100
              }
              bdColor={
                selectedMobility?.status === "운행중"
                  ? "rgba(92, 200, 109, 0.5)"
                  : "rgba(26, 39, 35, 0.5)"
              }
            >
              {selectedMobility?.mobility_image === null ? (
                <MobilityStyledImg
                  src={`${process.env.REACT_APP_BASE_URL}/img/${
                    deviceImageArray.find(
                      (list) =>
                        list.device === selectedMobility.mobility_type
                    )?.listFileName
                  }`}
                  alt="농기계 이미지"
                />
              ) : (
                <MobilityStyledImg
                  src={`${process.env.REACT_APP_BASE_URL}/${selectedMobility?.mobility_image}`}
                  isEtc
                  alt="농기계 이미지"
                />
              )}
            </ImageWrapperStyledDiv>
            <InfoWrapperStyledDiv>
              {/* 기기명[기기종류] */}
              <CustomTooltip
                title={selectedMobility.mobility_name}
                active={
                  selectedMobility.mobility_name?.length >
                  mobSubstringLength
                }
              >
                <MobilityNameStyledSpan>
                  {selectedMobility.mobility_name.length >
                  mobSubstringLength
                    ? selectedMobility.mobility_name.substring(
                        0,
                        mobSubstringLength -
                          selectedMobility.mobility_type.length
                      ) + "..."
                    : selectedMobility.mobility_name}
                  [{selectedMobility.mobility_type}]
                </MobilityNameStyledSpan>
              </CustomTooltip>

              {/* 소유자명 */}
              <CustomTooltip
                title={selectedMobility.name}
                active={
                  selectedMobility.name?.length > (width > md ? 30 : 16)
                }
              >
                <UserNameStyledSpan>
                  {t.control.ownerLabel} :
                  {textSubstring(
                    selectedMobility.name,
                    0,
                    width > md ? 30 : 16
                  )}
                </UserNameStyledSpan>
              </CustomTooltip>

              <LastRunTimeStyledSpan>
                {t.control.lastOperationTime} :
                {!selectedMobility.max_registered_at &&
                !selectedMobility.min_registered_at
                  ? t.control.noOperationRecord
                  : formatDate(
                      selectedMobility.max_registered_at ??
                        selectedMobility.min_registered_at,
                      "yyyy-MM-dd HH:mm:ss"
                    )}
              </LastRunTimeStyledSpan>
            </InfoWrapperStyledDiv>
          </ListItemStyledDiv>
        )}
        {/*  임차인 있음 */}
        {data && isLeased && (
          <ListItemStyledDiv
            hoverColor={theme.color.neutral_100}
            key={data.device_pid}
            active={true}
          >
            <ImageWrapperStyledDiv
              bgColor={
                data?.status === "운행중"
                  ? theme.color.green_100
                  : theme.color.neutral_100
              }
              bdColor={
                data?.status === "운행중"
                  ? "rgba(92, 200, 109, 0.5)"
                  : "rgba(26, 39, 35, 0.5)"
              }
            >
              {data?.mobility_image === null ? (
                <MobilityStyledImg
                  src={`${process.env.REACT_APP_BASE_URL}/img/${
                    deviceImageArray.find(
                      (list) => list.device === data.mobility_type
                    )?.listFileName
                  }`}
                  alt="농기계 이미지"
                />
              ) : (
                <MobilityStyledImg
                  src={`${process.env.REACT_APP_BASE_URL}/${data?.mobility_image}`}
                  isEtc
                  alt="농기계 이미지"
                />
              )}
            </ImageWrapperStyledDiv>
            <InfoWrapperStyledDiv>
              {/* 기기명[기기종류] */}
              <CustomTooltip
                title={data.mobility_name}
                active={data.mobility_name?.length > mobSubstringLength}
              >
                <MobilityNameStyledSpan>
                  {data.mobility_name.length > mobSubstringLength
                    ? data.mobility_name.substring(
                        0,
                        mobSubstringLength - data.mobility_type.length
                      ) + "..."
                    : data.mobility_name}
                  [{data.mobility_type}]
                </MobilityNameStyledSpan>
              </CustomTooltip>

              {/* 소유자명 */}
              <CustomTooltip
                title={data.lease_name}
                active={data.lease_name?.length > (width > md ? 30 : 16)}
              >
                <UserNameStyledSpan>
                  {t.control.ownerLabel} :
                  {textSubstring(data.lease_name, 0, width > md ? 30 : 16)}
                </UserNameStyledSpan>
              </CustomTooltip>

              <LastRunTimeStyledSpan>
                {t.control.lastOperationTime} :
                {!data.max_registered_at && !data.min_registered_at
                  ? t.control.noOperationRecord
                  : formatDate(
                      data.max_registered_at ?? data.min_registered_at,
                      "yyyy-MM-dd HH:mm:ss"
                    )}
              </LastRunTimeStyledSpan>
            </InfoWrapperStyledDiv>
          </ListItemStyledDiv>
        )}
      </SelectedMobWrapper>

      {/* 기기 리스트 */}
      <MobilityListStyledDiv ref={listRef}>
        {mobilityDataIsLoading && <Spinner />}
        {!isLeased &&
          mobilityData?.list.map((el) => {
            if (
              data &&
              (el.name === data.name || el.name === data.owner)
            ) {
              return (
                <ListItemStyledDiv
                  hoverColor={theme.color.neutral_100}
                  style={{ cursor: "pointer" }}
                  key={el.device_pid}
                  onClick={() => {
                    // 재클릭 방지
                    if (selectedMobility === el) {
                      return;
                    } else {
                      handleClickMobilityList(el);
                    }
                  }}
                  active={selectedMobility?.device_pid === el.device_pid}
                  role="button"
                  tabIndex={0}
                  onKeyDown={handleKeyDown}
                >
                  <ImageWrapperStyledDiv
                    bgColor={
                      el?.status === "운행중"
                        ? theme.color.green_100
                        : theme.color.neutral_100
                    }
                    bdColor={
                      el?.status === "운행중"
                        ? "rgba(92, 200, 109, 0.5)"
                        : "rgba(26, 39, 35, 0.5)"
                    }
                  >
                    {el?.mobility_image === null ? (
                      <MobilityStyledImg
                        src={`${process.env.REACT_APP_BASE_URL}/img/${
                          deviceImageArray.find(
                            (list) => list.device === el.mobility_type
                          )?.listFileName
                        }`}
                        alt="농기계 이미지"
                      />
                    ) : (
                      <MobilityStyledImg
                        src={`${process.env.REACT_APP_BASE_URL}/${el?.mobility_image}`}
                        isEtc
                        alt="농기계 이미지"
                      />
                    )}
                  </ImageWrapperStyledDiv>
                  <InfoWrapperStyledDiv>
                    {/* 기기명[기기종류] */}
                    <CustomTooltip
                      title={el.mobility_name}
                      active={
                        el.mobility_name?.length > mobSubstringLength
                      }
                    >
                      <MobilityNameStyledSpan>
                        {el.mobility_name != null
                          ? el.mobility_name.length > mobSubstringLength
                            ? el.mobility_name.substring(
                                0,
                                mobSubstringLength -
                                  el.mobility_type.length
                              ) + "..."
                            : el.mobility_name
                          : ""}
                        [{el.mobility_type}]
                      </MobilityNameStyledSpan>
                    </CustomTooltip>

                    {/* 소유자명 */}
                    <CustomTooltip
                      title={el.name}
                      active={el.name?.length > (width > md ? 30 : 16)}
                    >
                      <UserNameStyledSpan>
                        {t.control.ownerLabel} :{" "}
                        {textSubstring(el.name, 0, width > md ? 30 : 16)}
                      </UserNameStyledSpan>
                    </CustomTooltip>

                    <LastRunTimeStyledSpan>
                      {t.control.lastOperationTime} :
                      {!el.max_registered_at && !el.min_registered_at
                        ? t.control.noOperationRecord
                        : formatDate(
                            el.max_registered_at ?? el.min_registered_at,
                            "yyyy-MM-dd HH:mm:ss"
                          )}
                    </LastRunTimeStyledSpan>
                  </InfoWrapperStyledDiv>
                </ListItemStyledDiv>
              );
            }
          })}
      </MobilityListStyledDiv>
      {!isLeased && mobilityData && mobilityData.list.length > 0 && (
        <Pagination
          page={mobilityPage + 1}
          count={mobilityData?.total_page}
          onChange={handlePageChange}
          siblingCount={width > md ? 4 : width > sm ? 3 : 2}
          size="small"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            justifySelf: "end",
          }}
        />
      )}
    </MobilityWrapperStyledDiv>
  );
};

const MobilityWrapperStyledDiv = styled.div`
  background: ${theme.color.neutral_50};
  border: 3px solid ${theme.color.neutral_100};
  border-radius: 20px;
  padding-top: 20px;
  height: 435px;
  display: flex;
  flex-direction: column;
  position: relative;

  @media (max-width: ${lg}px) {
    width: 100%;
  }
  @media (min-width: ${lg + 1}px) {
    /* min-width: 534px;
    max-width: 534px; */
    min-width: 651px;
    max-width: 651px;
  }

  @media print {
    flex-grow: 1;
  }
`;

const ListTitleStyledH2 = styled.h2`
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: ${theme.color.neutral_600};
  padding-left: 25px;
  border-bottom: 3px solid ${theme.color.neutral_100};
  padding-bottom: 20px;
`;

const MobilityListStyledDiv = styled.div`
  border: 1px solid ${theme.color.neutral_100};
  /* border-bottom-right-radius: 20px;
  border-bottom-left-radius: 15px; */
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const ListItemStyledDiv = styled.div<{
  active?: boolean;
  hoverColor?: string;
}>`
  display: flex;
  gap: 20px;
  padding: 22px 20px;
  border-bottom: 1px solid ${theme.color.neutral_200};
  background-color: ${({ active }) =>
    active ? `${theme.color.neutral_100}` : `${theme.color.white}`};
  cursor: pointer;
  &:hover {
    background-color: ${({ hoverColor }) => hoverColor};
  }
  /* 선택된 항목이 제일 앞으로 */
  /* order: ${({ active }) => active && "-1"}; */
  position: relative;

  @media (max-width: ${sm}px) {
    gap: 10px;
    padding: 15px 10px;
  }
`;

const ImageWrapperStyledDiv = styled.div<{
  bgColor: string;
  bdColor: string;
}>`
  background-color: ${({ bgColor }) => bgColor};
  width: 65px;
  height: 61px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: ${({ bdColor }) => `3px solid ${bdColor}`};
  flex-shrink: 0;

  @media (max-width: ${sm}px) {
    width: 55px;
    height: 55px;
    align-self: center;
  }
`;

const MobilityStyledImg = styled.img<{ isEtc?: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: ${({ isEtc }) => (isEtc ? `fill` : `contain`)};
`;

const InfoWrapperStyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const MobilityNameStyledSpan = styled.span`
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: ${theme.color.neutral_700};

  @media (max-width: ${sm}px) {
    font-size: 14px;
  }
  @media (min-width: ${sm + 1}px) and (max-width: ${md}px) {
    font-size: 15px;
  }
`;

export const UserNameStyledSpan = styled.span`
  font-weight: 700;
  color: ${theme.color.neutral_700};
  font-size: 14px;
  line-height: 16px;
  @media (max-width: ${sm}px) {
    font-size: 12px;
  }
  @media (min-width: ${sm + 1}px) and (max-width: ${md}px) {
    font-size: 13px;
  }
`;

export const LastRunTimeStyledSpan = styled.span`
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: ${theme.color.neutral_500};
`;

const SelectedMobWrapper = styled.div`
  border: 3px solid ${theme.color.neutral_500};
  min-height: 116px;
  border-radius: 5px;

  @media (max-width: ${sm}px) {
    min-height: 102px;
  }
`;
// const LoaderWrapper = styled.div`
//   width: 100%;
//   height: 100%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;
